<template>
  <div class="body_monban">
    <el-tabs style="height: 200px;" v-model="activeName">
      <el-tab-pane label="门店展示"   name="mendian" >
        <tuwen  :tuwen_type="10"  :show_type="1" :update_flag ="1"></tuwen>
      </el-tab-pane>
      <!-- <el-tab-pane label="设备类型" name="macType"><macType></macType></el-tab-pane> -->
      <el-tab-pane label="极速救援"    name="jiuyuan">
        <tuwen :tuwen_type="11" :show_type="1" :update_flag ="1"></tuwen>
      </el-tab-pane>
      <el-tab-pane label="客户服务"   name="fuwu">
        <tuwen :tuwen_type="12"   :show_type="1" :update_flag ="1"></tuwen>
      </el-tab-pane>
      <el-tab-pane label="召集报名"    name="baoming">
        <tuwen :tuwen_type="13"   :show_type="1" :update_flag ="1"></tuwen>
      </el-tab-pane>
      <el-tab-pane label="糖豆介绍"   name="jieshao">
        <tuwen  :tuwen_type="14"   :show_type="1" :update_flag ="1"></tuwen>
      </el-tab-pane>
      <el-tab-pane label="投资加盟"    name="jiameng">
        <tuwen :tuwen_type="15"   :show_type="1" :update_flag ="1"></tuwen>
        <!-- 此处图片组件中，上传 和 更新到数据库是分离的，上传在子组件中完成，更新到数据由父组件调用，因为没有保存前，这些数据都有可能不需要保存 -->
     <!-- 数据返回直接由调用的存储过程返回图片uid参数 -->
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<style>
.body_moban {
  padding-top: 100px;
}
</style>
<script>

import tuwen from '../../tongyong/tuwen_com.vue'
export default {
  components: {
    tuwen: tuwen
  },

  data() {
    return {
      // 获取用户列表参数
      activeName: 'mendian'

    };
  },
  props: [],

  watch: {

  },
  created() {

  },
  mounted() {

  },
  methods: {

  }
}
</script>
